"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBulkEditProductsModal = void 0;
const react_1 = require("react");
const use_bulk_actions_filter_hook_1 = require("./use-bulk-actions-filter.hook");
const table_columns_1 = require("../../../common/table-columns");
/**
 * Controls the state of bulk edit modal
 */
const useBulkEditProductsModal = (_a) => {
    var { onBulkEditComplete, reviewAttribute } = _a, props = __rest(_a, ["onBulkEditComplete", "reviewAttribute"]);
    const [isBulkEditModalOpen, setBulkEditModalOpen] = (0, react_1.useState)(false);
    const bulkActionsFilter = (0, use_bulk_actions_filter_hook_1.useBulkActionsFilter)(props);
    const onSubmit = () => {
        setBulkEditModalOpen(false);
        onBulkEditComplete();
    };
    const onClose = () => {
        setBulkEditModalOpen(false);
    };
    return {
        isBulkEditModalOpen,
        setBulkEditModalOpen,
        bulkEditModalProps: {
            productsFilter: bulkActionsFilter,
            initialAttributeId: reviewAttribute ? (0, table_columns_1.parseColumnId)(reviewAttribute.id).label : undefined,
            onSubmit,
            onClose,
        },
    };
};
exports.useBulkEditProductsModal = useBulkEditProductsModal;
